import { shuffle } from "@educaplay/core";
import { areTextsEqual } from "@educaplay/core/utils";

export const formatText = (question) => {
    const { texto, palabras, unidas } = question;
    const filteredSortedWords = [...new Set(palabras.sort((a, b) => a - b))];
    let result = [];
    let currentIndex = 0;  // Posición actual en el texto
    const specialCharRegex = /[.,;:=*+\-_{}[\]¿?¡!()/&%$·|\\@ \n"]+/;  // Expresión regular de caracteres especiales

    for (let i = 0; i < filteredSortedWords.length; i++) {
        const palabraIndex = filteredSortedWords[i];

        // Añadir texto normal antes del hueco (si hay y no es vacío)
        if (currentIndex < palabraIndex) {
            const normalText = texto.slice(currentIndex, palabraIndex);
            if (normalText.trim().length > 0) {
                // Comprobar si el último objeto es un texto normal, para fusionar
                if (result.length > 0 && result[result.length - 1].isGap === false) {
                    result[result.length - 1].data += normalText;  // Unir al último bloque
                } else {
                    result.push({
                        data: normalText,  // Texto normal hasta el hueco
                        isGap: false
                    });
                }
            }
        }

        // Manejo de palabras unidas y búsqueda del final del hueco
        let gapEndIndex = palabraIndex;  // Final del hueco
        let match = texto.slice(palabraIndex).match(specialCharRegex);

        // Si encontramos un carácter especial, ese será el fin del hueco
        if (match) {
            gapEndIndex = palabraIndex + match.index;
        } else {
            // Si no se encuentran caracteres especiales, el hueco va hasta el final del texto
            gapEndIndex = texto.length;
        }

        // Verificar si hay palabras unidas al hueco
        while (i < filteredSortedWords.length - 1 && unidas.includes(filteredSortedWords[i + 1])) {
            i++;
            const nextGapEndIndex = filteredSortedWords[i];
            match = texto.slice(nextGapEndIndex).match(specialCharRegex);
            if (match) {
                gapEndIndex = nextGapEndIndex + match.index;
            } else {
                gapEndIndex = texto.length;
            }
        }

        // Añadir hueco (si no es vacío)
        const gapText = texto.slice(palabraIndex, gapEndIndex).trim();
        if (gapText.length > 0) {
            result.push({
                data: gapText,
                isGap: true,
                originId: palabraIndex
            });
        }

        // Actualizar el índice actual en el texto
        currentIndex = gapEndIndex;
    }

    // Añadir el resto del texto si queda algo después del último hueco (y no es vacío)
    if (currentIndex < texto.length) {
        const remainingText = texto.slice(currentIndex);
        if (remainingText.trim().length > 0) {
            // Comprobar si el último objeto es un texto normal, para fusionar
            if (result.length > 0 && result[result.length - 1].isGap === false) {
                result[result.length - 1].data += remainingText;
            } else {
                result.push({
                    data: remainingText,
                    isGap: false
                });
            }
        }
    }

    const paragraphResult = splitIntoParagraphs(result);

    const paragraphsWithId = addIdsToParagraphs(paragraphResult);

    return paragraphsWithId;
}

const splitIntoParagraphs = (result) => {
    let paragraphResult = [];
    let currentParagraph = [];

    result.forEach(item => {
        // Dividimos el 'data' si contiene '\n'
        const parts = item.data.split('\n');

        if (parts.length === 1) {
            // No hay salto de línea, se agrega al párrafo actual
            currentParagraph.push(item);
        } else {
            // Hay salto de línea, partimos el contenido en múltiples partes
            for (let i = 0; i < parts.length; i++) {
                if (parts[i] !== '') {
                    // Crear un nuevo objeto para cada parte
                    let newItem = { isGap: item.isGap, data: parts[i] };
                    
                    if (i === 0) {
                        // Primer fragmento va al párrafo actual
                        currentParagraph.push(newItem);
                    } else if (i === parts.length - 1) {
                        // Último fragmento va a un nuevo párrafo
                        currentParagraph = [newItem];
                    } else {
                        // Parte intermedia genera un nuevo párrafo
                        paragraphResult.push(currentParagraph);
                        currentParagraph = [newItem];
                    }
                }

                // Después de cada fragmento, si no es el último, cerramos el párrafo
                if (i < parts.length - 1) {
                    paragraphResult.push(currentParagraph);
                    currentParagraph = [];
                }
            }
        }
    });

    // Añadir el último párrafo si tiene contenido
    if (currentParagraph.length > 0) {
        paragraphResult.push(currentParagraph);
    }

    return paragraphResult.filter(paragraph => paragraph.length > 0)
}

const addIdsToParagraphs = (paragraphs) => {
    const paragraphsWithId =  paragraphs.map((paragraph, pIndex) => {
        return paragraph.map((block, bIndex) => {
            return {
                ...block,
                id: `${pIndex}-${bIndex}`
            }
        })
    })

    return paragraphsWithId;
}

export const isCorrectKeySensitive = (userAnswer, expected, keySensitive) => {
    const normalizaedUserAnswer = keySensitive.accent ? userAnswer.trim() : userAnswer.normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim();
    const capsUserAnswer = keySensitive.caps? normalizaedUserAnswer : normalizaedUserAnswer.toLowerCase();

    const normalizaedExpected = keySensitive.accent? expected.trim() : expected.normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim();
    const capsExpected = keySensitive.caps? normalizaedExpected : normalizaedExpected.toLowerCase();

    return areTextsEqual(capsUserAnswer, capsExpected);
}

export const generateDropdownOptions = ({arrayWithIds: dataArray, originalMap}) => {
    const newMap = {};

    // Recorremos cada sub-array
    dataArray.flat().forEach(item => {
        if (item.isGap && originalMap[item.originId]) {
            const options = [...originalMap[item.originId], item.data]
            newMap[item.id] = shuffle(options);
        }
    });

    return newMap;
};